import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_HOLD_RELEASESALARY);
var axios_instanse_update = get_axios_instance(api_variables.SERVICE_HOLD_RELEASE_STOP);
var axios_instance_get_status_list = get_axios_instance(api_variables.SERVICE_STATUS_LIST);
var axios_instance_update_status = get_axios_instance(api_variables.SERVICE_STATUS_UPDATE);
var axios_instance_upload_template = get_axios_instance(api_variables.SERVICE_BULK_UPLOAD)
const state = {
    data: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    record: {},
    status: ''
};

const getters = {
    status: (state) => {
        return state.status;
    },
    record: (state) => {
        return state.record;
    }
};
const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },
    setEditMode: (state, payload) => {
        state.status = payload.status;
        state.record = payload.record;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            let res = await axios_instance.post(`/`, payload);
            if (res.status == 200) {
                commit('set', res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async getStatusList({ commit }, payload) {
        try {
            let res = await axios_instance_get_status_list.get(`/`,{ 
            params: {
                le_id: payload
            }
        });
            if (res.status == 200) {
                commit('set', res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async updateEmployeeStatus({ commit }, payload) {
        try {
            let res = await axios_instance_update_status.post('/', payload);
            if (res.status == 200) {
                commit('set', res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async uploadTemplate({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``, payload);
            commit("setFetching", false);
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        try {
            commit('setEditMode', payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getEmployeeByIDStatus({ commit }, payload) {
        try {
            let res = await axios_instance_get_status_list.get(`/`,{ 
            params: {
                employee_id: "efd945a0-0777-475d-a46b-76a3bdf22aaf"
            }
        });
            if (res.status == 200) {
                commit('set', res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async holdReleaseAndStop({ commit }, payload) {
        try {
            let res = await axios_instanse_update.post('/', payload);
            if (res.status == 200) {
                commit('set', res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        try {
            commit('setEditMode', payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};